var sqrt3 = Math.sqrt(3);

export default {
  draw: function(context, size) {
    var y = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-shape/src/symbol/triangle.js
// module id = FFoX
// module chunks = 0